var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.09 21.5C21.09 21.78 20.87 22 20.59 22H3.41003C3.13003 22 2.91003 21.78 2.91003 21.5C2.91003 17.36 6.99003 14 12 14C13.03 14 14.03 14.14 14.95 14.41C14.36 15.11 14 16.02 14 17C14 17.75 14.21 18.46 14.58 19.06C14.78 19.4 15.04 19.71 15.34 19.97C16.04 20.61 16.97 21 18 21C19.12 21 20.13 20.54 20.85 19.8C21.01 20.34 21.09 20.91 21.09 21.5Z",
    fill: "#FB433A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.88 16.04C21.78 15.65 21.62 15.26 21.4 14.91C21.25 14.65 21.05 14.4 20.83 14.17C20.11 13.45 19.17 13.06 18.21 13.01C17.12 12.94 16.01 13.34 15.17 14.17C14.38 14.96 13.98 16.01 14 17.06C14.01 18.06 14.41 19.06 15.17 19.83C15.7 20.36 16.35 20.71 17.04 20.87C17.42 20.97 17.82 21.01 18.22 20.98C19.17 20.94 20.1 20.56 20.83 19.83C21.86 18.8 22.21 17.35 21.88 16.04ZM19.6 18.6C19.31 18.89 18.83 18.89 18.54 18.6L17.99 18.05L17.46 18.58C17.17 18.87 16.69 18.87 16.4 18.58C16.11 18.28 16.11 17.81 16.4 17.52L16.93 16.99L16.42 16.49C16.13 16.19 16.13 15.72 16.42 15.42C16.72 15.13 17.19 15.13 17.49 15.42L17.99 15.93L18.52 15.4C18.81 15.11 19.28 15.11 19.58 15.4C19.87 15.69 19.87 16.17 19.58 16.46L19.05 16.99L19.6 17.54C19.89 17.83 19.89 18.31 19.6 18.6Z",
    fill: "#FB433A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z",
    fill: "#FB433A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanned);
export default __webpack_public_path__ + "static/media/banned.85d544b934b2640f8743b4ec5534d73b.svg";
export { ForwardRef as ReactComponent };